// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.react-datepicker__triangle {
  display: none;
}

.error {
  color: red;
  font-size: 14px;
  line-height: 1;
  margin-bottom: 10px;
}

.datepicker_field {
  background-color: #ffffff;
  text-align: left;
}

.react-datepicker__time-list-item--disabled {
  display: none;
}

.datePickerField_hidden_time__omGXR {
  opacity: 0.3;
  pointer-events: none;
}

.datePickerField_datepicker__6bvcp {
  cursor: pointer;
}`, "",{"version":3,"sources":["webpack://./src/app/components/FormFields/DatePickerField/datePickerField.module.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;AACF;;AAEA;EACE,UAAA;EACA,eAAA;EACA,cAAA;EACA,mBAAA;AACF;;AAEA;EACE,yBAAA;EACA,gBAAA;AACF;;AAEA;EACE,aAAA;AACF;;AAEA;EACE,YAAA;EACA,oBAAA;AACF;;AAEA;EACE,eAAA;AACF","sourcesContent":[":global(.react-datepicker__triangle) {\n  display: none;\n}\n\n:global(.error) {\n  color: red;\n  font-size: 14px;\n  line-height: 1;\n  margin-bottom: 10px;\n}\n\n:global(.datepicker_field) {\n  background-color: #ffffff;\n  text-align: left;\n}\n\n:global(.react-datepicker__time-list-item--disabled) {\n  display: none;\n}\n\n.hidden_time {\n  opacity: 0.3;\n  pointer-events: none;\n}\n\n.datepicker {\n  cursor: pointer;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"hidden_time": `datePickerField_hidden_time__omGXR`,
	"datepicker": `datePickerField_datepicker__6bvcp`
};
export default ___CSS_LOADER_EXPORT___;
